/* ==========================================================================
   PeanutPup — Buy Now row
   --------------------------------------------------------------------------
   Deliberately does NOT reimplement variant logic. Instead it mirrors Dawn's
   own elements, so every bit of Dawn's variant handling (availability,
   currency formatting, quantity rules, section re-renders) is inherited:

     price     <- text of #price-{sectionId}
     disabled  <- the [name="add"] submit button's disabled state
     variant   <- the form's [name="id"] hidden input, read at click time
     quantity  -> written through to #Quantity-{sectionId}

   That means a Dawn upgrade or a variant-picker change can't desync it.
   ========================================================================== */
(function () {
  'use strict';

  var HAS_DIGIT = /[\d]/;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function PPBuyNow(el) {
    this.root = el;
    this.sectionId = el.getAttribute('data-section-id');
    this.formId = el.getAttribute('data-form-id');
    this.btn = el.querySelector('[data-pp-buynow]');
    this.priceOut = el.querySelector('[data-pp-buynow-price]');
    this.select = el.querySelector('[data-pp-buynow-qty]');
    this.error = el.querySelector('[data-pp-buynow-error]');
    if (!this.btn) return;

    this.container = el.closest('.product__info-container');
    if (this.container) this.container.classList.add('pp-has-buynow');

    this.bind();
    this.syncAll();
    this.observe();
  }

  /* ----- elements we mirror. Re-queried each time, because Dawn replaces
           these nodes wholesale on variant change. ----- */
  PPBuyNow.prototype.priceRoot = function () {
    return document.getElementById('price-' + this.sectionId);
  };

  PPBuyNow.prototype.form = function () {
    return document.getElementById(this.formId);
  };

  PPBuyNow.prototype.submitBtn = function () {
    var f = this.form();
    return f ? f.querySelector('[name="add"]') : null;
  };

  PPBuyNow.prototype.variantInput = function () {
    var f = this.form();
    return f ? f.querySelector('[name="id"]') : null;
  };

  PPBuyNow.prototype.dawnQty = function () {
    return document.getElementById('Quantity-' + this.sectionId);
  };

  /* ----- price ----- */
  PPBuyNow.prototype.readPrice = function () {
    var r = this.priceRoot();
    if (!r) return '';
    var price = r.querySelector('.price');
    var el = null;

    if (price && price.classList.contains('price--on-sale')) {
      el = price.querySelector('.price__sale .price-item--sale');
    }
    if (!el) el = r.querySelector('.price__regular .price-item--regular');
    if (!el) el = r.querySelector('.price-item--sale');
    if (!el) el = r.querySelector('.price-item');

    var txt = el ? el.textContent.replace(/\s+/g, ' ').trim() : '';
    return HAS_DIGIT.test(txt) ? txt : '';
  };

  PPBuyNow.prototype.syncPrice = function () {
    if (!this.priceOut) return;
    var p = this.readPrice();
    this.priceOut.textContent = p;
    if (p) this.btn.setAttribute('data-pp-ready', '');
    else this.btn.removeAttribute('data-pp-ready');
  };

  /* ----- availability ----- */
  PPBuyNow.prototype.syncAvailability = function () {
    var sb = this.submitBtn();
    if (!sb) return;
    if (sb.hasAttribute('disabled')) {
      this.btn.setAttribute('disabled', 'disabled');
      this.btn.setAttribute('aria-disabled', 'true');
    } else {
      this.btn.removeAttribute('disabled');
      this.btn.removeAttribute('aria-disabled');
    }
  };

  /* ----- quantity: our select is visible, Dawn's input is truth ----- */
  PPBuyNow.prototype.pushQty = function () {
    var dq = this.dawnQty();
    if (!dq || !this.select) return;
    dq.value = this.select.value;
    dq.dispatchEvent(new Event('change', { bubbles: true }));
  };

  PPBuyNow.prototype.pullQty = function () {
    var dq = this.dawnQty();
    if (!dq || !this.select) return;
    var v = String(parseInt(dq.value, 10) || 1);
    var exists = Array.prototype.some.call(this.select.options, function (o) {
      return o.value === v;
    });
    if (exists) this.select.value = v;
  };

  PPBuyNow.prototype.syncAll = function () {
    this.syncPrice();
    this.syncAvailability();
    this.pullQty();
  };

  /* ----- watch Dawn for variant changes ----- */
  PPBuyNow.prototype.observe = function () {
    var self = this;
    var target = this.container || document.body;

    this.mo = new MutationObserver(function () {
      if (self._raf) return;
      self._raf = requestAnimationFrame(function () {
        self._raf = null;
        self.syncPrice();
        self.syncAvailability();
      });
    });

    this.mo.observe(target, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['disabled', 'class']
    });

    document.addEventListener('variant:change', function () {
      self.syncAll();
    });
  };

  PPBuyNow.prototype.bind = function () {
    var self = this;

    if (this.select) {
      this.select.addEventListener('change', function () {
        self.pushQty();
      });
    }

    this.btn.addEventListener('click', function (e) {
      e.preventDefault();
      self.buy();
    });
  };

  PPBuyNow.prototype.showError = function (msg) {
    if (!this.error) return;
    this.error.textContent = msg;
    this.error.setAttribute('data-visible', '');
  };

  PPBuyNow.prototype.clearError = function () {
    if (!this.error) return;
    this.error.removeAttribute('data-visible');
    this.error.textContent = '';
  };

  /* ----- add, then go to checkout ----- */
  PPBuyNow.prototype.buy = function () {
    var self = this;
    if (this.btn.hasAttribute('disabled')) return;

    var vi = this.variantInput();
    var id = vi && vi.value;
    if (!id) {
      this.showError('Please choose an option first.');
      return;
    }

    this.clearError();
    this.btn.setAttribute('aria-busy', 'true');

    var qty = this.select ? parseInt(this.select.value, 10) || 1 : 1;

    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: id, quantity: qty })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart.');
          return data;
        });
      })
      .then(function () {
        window.location.href = root() + 'checkout';
      })
      .catch(function (err) {
        self.btn.removeAttribute('aria-busy');
        self.showError(err.message || 'Something went wrong. Please try again.');
      });
  };

  function init() {
    document.querySelectorAll('[data-pp-buynow-root]').forEach(function (el) {
      if (!el.__ppBuyNow) el.__ppBuyNow = new PPBuyNow(el);
    });
  }

  ready(init);
  document.addEventListener('shopify:section:load', init);
})();
